export default "__VITE_ASSET__DMWn02Gw__"